// extracted by mini-css-extract-plugin
export default {"infoContainer":"VerificationComplete_infoContainer__pGPNo","doneIcon":"VerificationComplete_doneIcon__M1mQi"};